let lastUID = -1;

class EventBus {
  constructor() {
    if (!EventBus.instance) {
      this.events = {};
      
      EventBus.instance = this;
    }
    
    return EventBus.instance;
  }
  
  subscribe(eventType, func) {
    if (typeof func !== 'function') {
      return false;
    }
    
    // event is not registered
    if (!this.events.hasOwnProperty(eventType)) {
      this.events[eventType] = {};
    }
    
    const token = `uid_${lastUID += 1}`;
    
    this.events[eventType][token] = func;
    
    return token;
  }
  
  publish(eventType, data) {
    if (!this.events[eventType]) {
      // console.error(`No subscribers for event ${eventType}`);
      return false;
    }
    
    const subscribers = this.events[eventType];
    
    for (var s in subscribers) {
      subscribers[s](data);
    }
  }
  
  unsubscribe(token) {
    let result = false;
    let event;
    
    for (var e in this.events) {
      if (this.events.hasOwnProperty(e)) {
        event = this.events[e];
        
        if (event[token]) {
          delete event[token];
          result = token;
        }
      }
    }
    
    return result;
  }
  
  allEvents() {
    console.log(this.events);
    return;
  }
}

const instance = new EventBus();

export default instance;